import detailsTabModule from './details/details';
import groupsTabModule from './groups/groups';
import historyTabModule from './history/history';

export default angular
  .module('main.reports.view.tabs', [
    detailsTabModule,
    groupsTabModule,
    historyTabModule,
  ])
  .name;
